import { Component, computed, inject, Signal, signal } from '@angular/core';
import { SidebarService } from '../../services/sidebar.service';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LINKS, SUBLINKS } from '../../constants/links.constants';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebarmenu',
  imports: [RouterLink, RouterLinkActive, TranslateModule],
  templateUrl: './sidebarmenu.component.html',
  styleUrl: './sidebarmenu.component.css'
})
export class SidebarmenuComponent {
  isOpen!: Signal<boolean>;
  isSubMenuOpen = signal(false);

  links = LINKS;
  sublinks = SUBLINKS;

  private translate = inject(TranslateService);

  constructor(public sidebarService: SidebarService) {
    this.isOpen = this.sidebarService.isSidebarOpen;
  }

  get currentLang(): string {
    return this.translate.currentLang || 'es';
  }

  toggleLanguage() {
    const newLang = this.currentLang === 'es' ? 'en' : 'es';
    this.translate.use(newLang);
  }

  toggleSubMenu() {
    this.isSubMenuOpen.update(value => !value);
  }

  closeSidebar() {
    this.sidebarService.close();
    this.isSubMenuOpen.set(false);
  }
}
